'use strict';
(function($){
	/*
	 * Vetology.Store widget
	 *
	 * @description This is the main Vetology Store widget that needs a description right here
	 *
	 * @options					See description for each option
	 *
	 * @method	See description above each method
	 */
	$.widget(
		'Vetology.Store',
		{
			"options": {
			},
			/*
			 * Vetology.Store._init
			 *
			 * @description	Initializes the Vetology.Store
			 *
			 * @return NULL
			 *
			 */
			"_init": function(){
				var o = this;
				o._setEventHandlers();
			},
			/*
			 * Vetology.Store._doSomething
			 *
			 * @description	Placeholder for a method
			 *
			 * @return NULL
			 *
			 */
			"_setEventHandlers": function(){
				var o = this;
				$("body").on("click", ".plan_selector", function(e){
					var el = $(this);
					o._triggerPurchaseOptions(el, 0);
				});
				$("body").on("click", ".get_storage_plans", function(){
					$(".storage_plan_selector").removeClass("hide");
				});
				$("body").on("click", ".plan_more_info", function(){
					o._viewPlan($(this));
				});
				$("body").on("change", ".plan_selector_plan_usage", function(){
					o._togglePlanSelector();
				});
				$("body").on("change", ".plan_selector_group, .plan_selector_clinic", function(){
					o._getStoragePlans();
				});
			},
			/*
			 * Vetology.PatientSwissKnife._triggerPurchaseOptions
			 *
			 * @description	GEts settings for purchasing a plan.
			 *
			 * @return NULL
			 *
			 */
			"_triggerPurchaseOptions": function(el, p){
				var o = this;
				var data = {
					plan: el.data("plan"),
					blocks: el.data("blocks"),
					report: el.data("report"),
					target: el.data("target"),
					rate: el.data("rate"),
					cid: o.options.id,
				};
				$("body").Vetology("vetologyLoadStart", "<strong>Please wait:</strong> We are now redirecting you to PayPal to complete the payment");
				$.ajax(
					{
						type: 'GET', 
						url: "/patient-manager/get-report-plan", 
						dataType: 'JSON',
						data: data,
						success: function (data){
							$(".payment_processing").html(data.form);
							$(".on_purchasing").submit();
						}
					}
				);
			},
			/*
			 * Vetology.Store._viewPlan
			 *
			 * @description	Placeholder for a method
			 *
			 * @return NULL
			 *
			 */
			"_viewPlan": function(el){
				var id = el.data("plan");
				$(".plan_descriptions > div").addClass("hide");
				$(".plan_descriptions > div.plan_" + id).removeClass("hide");
			},
			/*
			 * Vetology.Store._togglePlanSelector
			 *
			 * @description	Placeholder for a method
			 *
			 * @return NULL
			 *
			 */
			"_togglePlanSelector": function(){
				var o = this;
				var type = $(".plan_selector_plan_usage").val();
				switch(type){
					case 'own_usage':
						$(".clinic_selector").addClass("hide");
						$(".clinic_group_selector").addClass("hide");
						$(".storage_plan_selector_select").addClass("hide");
						o._getStoragePlans();
					break;
					case 'clinic_usage':
						$(".clinic_selector").removeClass("hide");
						$(".clinic_group_selector").addClass("hide");
						$(".storage_plan_selector_select").addClass("hide");
					break;
					case 'clinic_group_usage':
						$(".clinic_selector").addClass("hide");
						$(".clinic_group_selector").removeClass("hide");
						$(".storage_plan_selector_select").addClass("hide");
					break;
				}
			},
			/*
			 * Vetology.Store._getStoragePlans
			 *
			 * @description	Placeholder for a method
			 *
			 * @return NULL
			 *
			 */
			"_getStoragePlans": function(){
				var o = this;
				var d = {
					get: "storage_plans",
					type: $(".plan_selector_plan_usage").val(),
					clinic: $(".plan_selector_clinic").val(),
					group: $(".plan_selector_group").val()
				};
				$("body").Vetology("doRequest", "GET", d, "/user/account", function(data){
					$(".storage_plan_selector_select").removeClass("hide").html(data);	
				}, "html", true, "Please wait while I get the available plans", "I am almost ready...");
			}
		}
	);
})(jQuery);